import {useLocalStorage} from '@aboutyou/storage';
import {STORAGE_SEARCHES_KEY} from './constants';

const MAX_STORED_HISTORY_TERMS = 6;

type StoredSearches = {
  terms: Array<{term: string}>;
};

export const useStoredSearchTerms = ({
  limitSearchHistory,
}: {
  limitSearchHistory?: boolean;
}) => {
  const [historySearchTerm, addSearchTermToHistory] =
    useLocalStorage<StoredSearches>({
      key: STORAGE_SEARCHES_KEY,
      defaultValue: {terms: []},
    });

  const handleAddSearchTerm = ({term}: {term: string}) => {
    if (
      !historySearchTerm?.terms ||
      historySearchTerm.terms.find(item => item.term === term)
    ) {
      return;
    }

    const limitedHistorySearchTerm = limitSearchHistory
      ? historySearchTerm?.terms.slice(0, MAX_STORED_HISTORY_TERMS)
      : historySearchTerm?.terms;

    addSearchTermToHistory({
      terms: [{term}, ...(limitedHistorySearchTerm || [])],
    });
  };

  const clearHistory = () => {
    addSearchTermToHistory({terms: []});
  };

  const handleRemoveSearchTerm = ({term}: {term: string}) => {
    if (!historySearchTerm?.terms.some(item => item.term === term)) {
      return;
    }

    addSearchTermToHistory({
      terms: historySearchTerm.terms.filter(item => item.term !== term),
    });
  };

  return {
    recentTerms: historySearchTerm?.terms || [],
    addSearchTerm: handleAddSearchTerm,
    removeSearchTerm: handleRemoveSearchTerm,
    clearHistory,
  };
};
